import { Link } from "react-router-dom"
import useLocationsNeedingAttention from "../hooks/useLocationsNeedingAttention"

const LocationsNeedingAttentionBanner = ({
    inCategory
}: {
    inCategory: 'event-admins' | 'event-checkins' | 'direct-mail' | 'passare' | 'fca' | 'online-arrangement' | 'webhooks'
}) => {
    const { locationsNeedingAttention, loading, errorMessage } = useLocationsNeedingAttention(inCategory)

    if (loading) {
        return <div className='p-10 pb-0'>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    }

    if (errorMessage) {
        return <div className='p-10 pb-0'>
            <div className="alert alert-danger" role="alert">
                {errorMessage}
            </div>
        </div>
    }

    if (locationsNeedingAttention.length === 0) {
        return null
    }

    return <div className='p-10 pb-0'>
        <div className="alert alert-warning" role="alert">
            <span className="text-dark fw-bolder">
                The following funeral homes need attention:
            </span>
            <ul className='mt-2 pb-0 mb-0'>
                {locationsNeedingAttention.map(location => (
                    <li key={location.unique_identifier}>
                        {inCategory === 'fca' ? (
                            <Link to={`/fca/manage-org/${location.unique_identifier}`}>
                                {location.org_name}
                            </Link>
                        ) : (
                            <Link to={`/service-locations/${location.unique_identifier}/settings`}>
                                {location.name}
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    </div>
}

export default LocationsNeedingAttentionBanner